var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.021,
    height: 30.002,
    viewBox: "0 0 36.021 30.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-upload-cloud",
    "data-name": "Icon feather-upload-cloud",
    transform: "translate(0.014 -2.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_657",
    "data-name": "Caminho 657",
    d: "M24,24l-6-6-6,6",
    fill: "none",
    stroke: "#6f2c91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_658",
    "data-name": "Caminho 658",
    d: "M18,18V31.5",
    fill: "none",
    stroke: "#6f2c91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_659",
    "data-name": "Caminho 659",
    d: "M30.585,27.585A7.5,7.5,0,0,0,27,13.5H25.11A12,12,0,1,0,4.5,24.45",
    fill: "none",
    stroke: "#6f2c91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_660",
    "data-name": "Caminho 660",
    d: "M24,24l-6-6-6,6",
    fill: "none",
    stroke: "#6f2c91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload_cloud.6990692532ce15bcfcf2c4f05f99ddb3.svg";
export { ForwardRef as ReactComponent };